import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    document.getElementById("app").scrollTo(0, 0);

    const mybutton = document.getElementById("scrollTopBtn");
    window.onscroll = function () {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        mybutton.style.display = "block";
      } else {
        mybutton.style.display = "none";
      }
    };
  }, [location]);

  function topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  return (
    <div className="scroll-to-top">
      <button onClick={topFunction} id="scrollTopBtn" title="Go to top">
        <i className="fa fa-solid fa-caret-up"></i>
      </button>
    </div>
  );
};

export default ScrollToTop;
